import React from "react";
import {
  Collapse,
  Navbar,
  Nav,
  NavItem,
  NavbarToggler,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Grid } from "@mui/material";
import classes from "./IndexNavbar.module.css";
import separator from "../../Assets/images/separator.png";
import logo from "../../Assets/images/matching-platform-menu-logo.png";
import GlobalContext from "../../Context/GlobalContext";
import { useNavigate, Link, useLocation } from "react-router-dom";
import avatar from "../../Assets/images/fa-regular_user.png";
import { useTranslation } from "react-i18next";
import i18n from "../../i18n";

export default function IndexNavbar() {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = React.useState(false);
  const [isOpenUserDropdown, setIsOpenUserDropdown] = React.useState(false);
  const [isLangOpen, setIsLangOpen] = React.useState(false);
  const context = React.useContext(GlobalContext);

 

  const navigate = useNavigate();
  const toggle = () => setIsOpen(!isOpen);

  const onSettingsClick = () => navigate("/profile");

  const handleItemClick = (e, pathname) => {
    e.preventDefault();
    navigate(pathname);
  };

  const location = useLocation();

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    localStorage.setItem("lang", lang);
  };

  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} md={10}>
        <Navbar light expand="xxl">
          {/* Logo */}
          <Nav>
            <Link to="/">
              <img alt="logo" src={logo} className={classes["logo"]} />
            </Link>
          </Nav>
          <NavbarToggler onClick={toggle} className={classes["navbar-toggler-custom"]} />
          <Collapse isOpen={isOpen} navbar>
            {/* Navbar Items */}
            <Nav className="mx-auto" navbar>
              <NavItem
                className={`mx-auto ${classes.navItem} ${location.pathname === "/" ? classes.activeNavItem : ""
                  }`}
                onClick={() => (window.location.href = "/")}
              >
                {t("navbar.home", "Accueil")}
              </NavItem>
              <NavItem
                className={`mx-auto ${classes.navItem} ${location.pathname === "/intervenants" ? classes.activeNavItem : ""
                  }`}
                onClick={(e) => handleItemClick(e, "/intervenants")}
              >
                {t("navbar.intervenants", "Intervenants")}
              </NavItem>
              <NavItem
                className={`mx-auto ${classes.navItem}`}
                onClick={() =>
                  window.open("https://yanacom.fr/", "_blank", "noopener,noreferrer")
                }
              >
                {t("navbar.shop", "Boutique")}
              </NavItem>
              <NavItem
                className={`mx-auto ${classes.navItem} ${location.pathname === "/contact" ? classes.activeNavItem : ""
                  }`}
                onClick={(e) => handleItemClick(e, "/contact")}
              >
                {t("navbar.contact", "Contact")}
              </NavItem>
            </Nav>

            {/* Right Side: User + Language */}
            <Nav className="d-flex align-items-center" navbar>
              {/* Language Dropdown */}
              <Dropdown isOpen={isLangOpen} toggle={() => setIsLangOpen(!isLangOpen)} nav>
                <DropdownToggle nav caret>
                  {i18n.language.toUpperCase()}
                </DropdownToggle>
                <DropdownMenu right>
                  <DropdownItem onClick={() => changeLanguage("fr")}>Français</DropdownItem>
                  <DropdownItem onClick={() => changeLanguage("en")}>English</DropdownItem>
                </DropdownMenu>
              </Dropdown>

              {/* User / Login */}
              {context.isLoggedIn ? (
                <Dropdown
                  isOpen={isOpenUserDropdown}
                  toggle={() => setIsOpenUserDropdown(!isOpenUserDropdown)}
                >
                  <DropdownToggle nav>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <img src={avatar} alt="avatar" className={classes.avatar} />
                      <span className={classes.name}>
                        {context.client && (
                          <>
                            {t("navbar.greeting")} {context.client.prenom_client} {context.client.nom_client}
                          </>
                        )}
                      </span>
                      <i className="fa-solid fa-caret-down"></i>
                    </div>
                  </DropdownToggle>
                  <DropdownMenu>
                    <DropdownItem onClick={onSettingsClick}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <i className="fa-solid fa-gear"></i>
                        <h5 className={classes.dropdownItemText} style={{ margin: "10px" }}>
                          {t("navbar.profile", "Espace client")}
                        </h5>
                      </div>
                    </DropdownItem>
                    <DropdownItem onClick={context.logout}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <i className="fa-solid fa-arrow-right-from-bracket"></i>
                        <h5 className={classes.dropdownItemText} style={{ color: "#4AAE9B", margin: "10px" }}>
                          {t("navbar.logout", "Déconnecter")}
                        </h5>
                      </div>
                    </DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              ) : (
                <div
                  style={{
                    display: "flex",
                    gap: "20px",
                    alignItems: "center",
                    justifyContent: "center",
                    marginRight: "15px",
                    marginLeft: "20px",
                    whiteSpace: "nowrap",
                  }}
                >
                  <NavItem className={classes.connectItem} onClick={(e) => handleItemClick(e, "/login")}>
                    <img src={avatar} className={classes["icon-action"]} alt="Se connecter" />
                    <span className="custom-margin-left">{t("navbar.login", "Se connecter")}</span>
                  </NavItem>
                  <NavItem>
                    <img src={separator} className={classes["separator"]} alt="Separator" aria-hidden="true" />
                  </NavItem>
                  <NavItem className={classes.signupItem} onClick={(e) => handleItemClick(e, "/signup")}>
                    {t("navbar.signup", "S'inscrire")}
                  </NavItem>
                </div>
              )}
            </Nav>
          </Collapse>
        </Navbar>
      </Grid>
    </Grid>
  );
}